import {
  PROJECT_URL,
  PROJECT_CONSULTATION,
  FEEDBACK_ON_CONTACTOR,
  SUGGEST_MORE_CONTRACTORS,
  FOLLOW_UP_REQUEST,
  CLICK_ON_CONTRACTOR,
} from "api/routes";
import {
  noAuthInstance,
  instance,
} from "hooks/useRequest/helper";

export const createProject = async (body) => {
  return await noAuthInstance
    .post(PROJECT_URL, { ...body })
    .then((res) => res.data);
};

export const reqConsultation = async ({ id }) => {
  const user = await JSON.parse(localStorage.getItem("user"));
  return await instance
    .post(PROJECT_CONSULTATION + "/" + id, {
      headers: {
        authorization: `Token ${user.token}`,
      },
    })
    .then((res) => res.data);
};

export const feedBackOnContractor = async (data) => {
  const { id, body } = data;
  const user = await JSON.parse(localStorage.getItem("user"));
  return await instance
    .put(
      FEEDBACK_ON_CONTACTOR + id,
      { ...body },
      {
        headers: {
          authorization: `Token ${user.token}`,
        },
      }
    )
    .then((res) => res.data);
};

export const followUpRequest = async (body) => {
  const { projectId, requestId } = body;
  const user = await JSON.parse(localStorage.getItem("user"));

  return await instance
    .post(FOLLOW_UP_REQUEST + projectId + "/" + requestId, {
      headers: {
        authorization: `Token ${user.token}`,
      },
    })
    .then((res) => res.data);
};

export const suggestMore = async (body) => {
  const projectId = localStorage.getItem("projectId");
  const user = await JSON.parse(localStorage.getItem("user"));
  return await instance
    .post(
      SUGGEST_MORE_CONTRACTORS + projectId,
      {
        body,
      },
      {
        headers: {
          authorization: `Token ${user.token}`,
        },
      }
    )
    .then((res) => res.data);
};

export const clickOnContractor = async () => {
  const id = localStorage.getItem("projectId");
  const user = await JSON.parse(localStorage.getItem("user"));

  return await instance
    .post(CLICK_ON_CONTRACTOR + "/" + id, {
      headers: {
        authorization: `Token ${user.token}`,
      },
    })
    .then((res) => res.data);
};

export const updateProject = async ({ data, id }) => {
  const user = await JSON.parse(localStorage.getItem("user"));

  return await instance
    .put(
      PROJECT_URL + "/" + id,
      {
        ...data,
      },
      {
        headers: {
          authorization: `Token ${user.token}`,
        },
      }
    )
    .then((res) => res.data);
};
